var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-menu-item md-elevation-4",on:{"click":_vm.onSelect}},[_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('md-icon',{staticClass:"arrow-icon"},[_vm._v(" chevron_right ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }